export default __webpack_public_path__ + "2c154b0f8c0d8d1661627d1ddb317b12.woff2";